import _ from '@lodash';
import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ListView from './listView';

function AssetsDashboard(props) {
	const [data, setData] = useState({});
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(false);
	const endUsersAccountsMod = props.endUsersAccounts
	
	if(loading){
		return (<FuseLoading/>)
	}
	if (false) {
		return (
			<div>
				<Card>
					<CardContent>You don't have permission to view any Subscription Providers at this time. Please contact your Systems Administrator for access.</CardContent>
				</Card>
			</div>
		)
	}
	return (
		<div className="w-full flex flex-col">
			<SwitchView 
            selectedView={props.selectedView} endUsersAccounts={endUsersAccountsMod}
			/>
			
		</div>
	);
}
function SwitchView({
	// endUsersAccounts,
	selectedView,
}) {
	if(true){
		return(
			<ListView 
			/>)
	}		
}
export default withRouter(AssetsDashboard)
